// Make sure to load Olark Chat last. It is the lowest priority item and needs to avoid blocking the main thread.
jQuery(window).on('load', async function () {
  jQuery(document).ready(function () {
    setTimeout(function () {
      (function (o, l, a, r, k, y) { if (o.olark) return; r = "script"; y = l.createElement(r); r = l.getElementsByTagName(r)[0]; y.async = 1; y.src = "//" + a; r.parentNode.insertBefore(y, r); y = o.olark = function () { k.s.push(arguments); k.t.push(+new Date) }; y.extend = function (i, j) { y("extend", i, j) }; y.identify = function (i) { y("identify", k.i = i) }; y.configure = function (i, j) { y("configure", i, j); k.c[i] = j }; k = y._ = { s: [], t: [+new Date], c: {}, l: a }; })(window, document, "static.olark.com/jsclient/loader.js");
      /* custom configuration goes here (www.olark.com/documentation) */
      olark.identify('5532-167-10-6916');

      /* //2021-10-14 not needed as it's a setting in Olark https://www.olark.com/extensions/greeter
    // Delay Attention Grabber popup for 30 seconds
    jQuery(document).ready(function() {
      console.log('olark');
        setTimeout(function() {
            jQuery('body').addClass('olark-visible');
        }, 30000)
    });
    */

      if (document.documentElement.lang == 'fr-CA') {
        /*Routes to French Group*/
        olark.configure('system.group', 'f446b129790d1dc14966327b82cd8fa9');
        olark.configure("system.localization", "fr-FR");
        olark.configure("locale.welcome_title", "Clavarder en direct");
        olark.configure("locale.chatting_title", "Clavardage en cours");
        // olark.configure("locale.unavailable_title", "Communiquez avec nous!");
        // olark.configure("locale.away_message", "Nous ne sommes pas disponibles pour l’instant. Veuillez nous laisser vos coordonnées ci-dessous et nous recommuniquerons avec vous.");
        // olark.configure("locale.loading_title", "Chargement d’Olark en cours...");
        olark.configure("locale.welcome_message", "Bonjour, que puis-je faire pour vous aider?");
        // olark.configure("locale.chat_input_text", "Entrez votre texte ici puis appuyez sur Entrée pour clavarder.");
        // olark.configure("locale.name_input_text", "Inscrivez votre nom *");
        // olark.configure("locale.phone_input_text", "Entrez votre numéro de téléphone.");
        // olark.configure("locale.email_input_text", "Entrez votre adresse courriel *");
        // olark.configure("locale.offline_note_message", "Message ou question");
        // olark.configure("locale.send_button_text", "Envoyer");
        // olark.configure("locale.offline_note_thankyou_text", "Merci de nous avoir envoyé un message. Nous vous répondrons dans les 24 heures qui suivent. Si vous désirez communiquer avec nous directement, veuillez composer le 1 877 289-3997.");
        // olark.configure("locale.offline_note_error_text", "Vous devez remplir tous les champs et entrer une adresse électronique valide.");
        // olark.configure("locale.offline_note_sending_text", "En cours d’envoi...");
        // olark.configure("locale.operator_is_typing_text", "est en train d’écrire...");
        // olark.configure("locale.operator_has_stopped_typing_text", "a cessé d’écrire");
        // olark.configure("locale.introduction_error_text", "Veuillez entrer votre nom et courriel si vous perdez la connexion.");
        olark.configure("locale.introduction_messages", "Bienvenue à notre clavardage en ligne. Veuillez remplir le formulaire ci-dessous pour commencer.");
        olark.configure("locale.prechat_survey_welcome_message", "Bienvenue à notre clavardage en ligne. Veuillez remplir le formulaire ci-dessous pour commencer.");
        olark.configure("locale.prechat_survey_submit_button_text", "Commencer à clavarder");
        // olark.configure("locale.introduction_submit_button_text", "Commencer à clavarder");
        // olark.configure("locale.disabled_input_text_when_convo_has_ended", "Conversation terminée. Actualisez pour lancer une nouvelle conversation.");
        // olark.configure("locale.disabled_panel_text_when_convo_has_ended", "Cette conversation est terminée, mais vous n’avez qu’à actualiser cette page pour en commencer une nouvelle!");

        // // This message is sent when using chat limits per operators
        // olark.configure("locale.ended_chat_message", "Cette conversation est terminée. Commencez à écrire ci-dessous si vous avez besoin d’autre chose!");

        // olark.configure("locale.cobrowsing_notify_visitor_end_text", "La conavigation est terminée.");
        // olark.configure("locale.cobrowsing_confirm_control_text", "Est-ce que vous voulez que l’opérateur ou l’opératrice contrôle votre navigateur?");
        // olark.configure("locale.cobrowsing_notify_visitor_control_text", "L’opérateur ou l’opératrice contrôle maintenant votre navigateur.");
        // olark.configure("locale.cobrowsing_visitor_confirm_allow_message", "Permettez-vous à l’opérateur ou à l’opératrice de voir la fenêtre de votre navigateur?");
        // olark.configure("locale.cobrowsing_visitor_confirm_allow_button_start", "Lancer le partage.");
        // olark.configure("locale.cobrowsing_visitor_confirm_allow_button_decline", "Refuser.");
        // olark.configure("locale.cobrowsing_visitor_allow_approve_message", "Vous partagez maintenant votre navigateur.");
        // olark.configure("locale.cobrowsing_allow_approve_button_stop", "Mettre fin au partage.");
        // olark.configure("locale.cobrowsing_notify_visitor_decline_text", "La conavigation a été refusée.");

        // //changes the attention grabber to french
        // //olark.configure('CalloutBubble.bubble_image_url', 'https://www.bayshore.ca/wp-content/uploads/2018/05/bayshore-call-rep-v2-FR.png');
        //olark.configure("WelcomeAssist.welcome_messages", "Bonjour, que puis-je faire pour vous aider?");        
      } else {
        /*Routes to English Group*/        
        olark.configure("system.localization", "en-US"); 
        olark.configure("locale.welcome_title", "Now Chatting");
        olark.configure("locale.chatting_title", "Live Chat");
        //olark.configure("locale.introduction_messages", "Hi! Let's get some quick info so we can better serve you:");
        olark.configure("locale.prechat_survey_welcome_message", "Hi! Let's get some quick info so we can better serve you:");
        //olark.configure("WelcomeAssist.welcome_messages", "Hello. How can I assist you today?");
        olark.configure("locale.welcome_message", "Hello. How can I assist you today?");
        olark.configure("locale.prechat_survey_submit_button_text", "Start Chatting");
        olark.configure('system.group', 'ccc70ee1c26605029e4aedc23580e401');
      }

      /* large chatbox */
      olark.configure('system.hb_chatbox_size', 'lg');

      // Dunham 2018-05-07: hide chat only on homepage
      /*var is_root = location.pathname == "/";
      if (is_root) {
        olark('api.box.hide');
      }*/

      // Custom event listener for tracking conversions
      function trackConversation(event) {
        // dataLayer.push({'event': event});

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: event,
        });
      }
      olark("api.chat.onBeginConversation", function () {
        trackConversation('olark_conversation');
      });

    }, 10000)
  });
});